import { useNavigate, useLocation } from "react-router-dom";
import { Building2, Mail, Landmark, Rocket, Home } from "lucide-react";

const pages = [
  { path: "/", label: "Home", icon: Home },
  { path: "/agenzie", label: "Agenzie", icon: Building2 },
  { path: "/email", label: "Email", icon: Mail },
  { path: "/enti", label: "Enti", icon: Landmark },
  { path: "/roadmap", label: "Roadmap", icon: Rocket },
];

export const InternalNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav data-testid="internal-nav" className="flex flex-wrap gap-2 justify-center py-4">
      {pages.map(p => (
        <button
          key={p.path}
          data-testid={`nav-link-${p.path === "/" ? "home" : p.path.slice(1)}`}
          onClick={() => navigate(p.path)}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all ${
            pathname === p.path
              ? "bg-[#4285F4] text-white"
              : "bg-white/10 text-[#9CA3AF] hover:bg-white/20 hover:text-white border border-white/10"
          }`}
        >
          <p.icon className="w-3.5 h-3.5" />
          {p.label}
        </button>
      ))}
    </nav>
  );
};
